import type { SerializedError } from '@reduxjs/toolkit'
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query'

/**
 * The HTTP status an RTK Query error carries, whether or not the response body could be read.
 *
 * `fetchBaseQuery` reports `status` as the HTTP code only when it could parse the body as JSON. A refusal whose body
 * is not JSON (for example one written by a gateway or a request filter rather than by the service itself) arrives as
 * `{ status: 'PARSING_ERROR', originalStatus: 400 }`, so reading `status` alone would not recognise it as the 400 it is.
 */
export const getHttpErrorStatus = (error: FetchBaseQueryError | SerializedError | undefined): number | undefined => {
  const { status, originalStatus } = (error ?? {}) as { status?: unknown; originalStatus?: unknown }
  if (typeof status === 'number') return status
  if (status === 'PARSING_ERROR' && typeof originalStatus === 'number') return originalStatus
  return undefined
}
